import React, { useState, useEffect, useContext } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OButton from 'components/reusable/OButton'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthContext from 'context/AuthContext'

const { startCase, capitalize } = require('lodash')
const SubEdit = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const items = location.state
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      name: items?.name,
      email: items?.email,
      permission: items?.permission
    }
  })

  const { updatePageName } = useContext(AuthContext)
  const notification = useToastContext()
  const [permissionJson, setPermissionJson] = useState([])
  const [isDisable, setIsDisable] = useState(true)
  const onChange = event => {
    setIsDisable(false)
    setPermissionJson(current =>
      current.map(obj => {
        if (obj.manager === event.target.name) {
          if (event.target.id === 'add' && event.target.checked)
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          if (event.target.id === 'edit' && event.target.checked)
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          return { ...obj, [event.target.id]: event.target.checked }
        }

        return obj
      })
    )
  }

  const onSubmit = async data => {
    const myData = { ...data }
    try {
      const myObj = {
        manager: 'dashboard',
        add: true,
        edit: true,
        view: true
      }

      const permission = JSON.stringify([myObj, ...permissionJson])
      const sendData = { ...myData, permission }
      const path = apiPath.editSubadmin + '/' + items._id
      const result = await apiPut(path, sendData)
      if (result?.data?.success) {
        navigate('/sub-admin-manager')
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
      }
    } catch (error) {
      console.log('error in get all sub admin list==>>>>', error.message)
    }
  }
  useEffect(() => {
    setPermissionJson(items?.permission?.slice(1))
  }, [])

  useEffect(() => {
    updatePageName(t('EDIT_SUB_ADMIN'))
  }, [])

  return (
    <>
      <div className='relative p-6 flex-auto'>
        <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 w-full'>
          <div className='px-2 flex'>
            <OInputField
              wrapperClassName='relative z-0 mb-6 w-full group'
              name='name'
              inputLabel={
                <>
                  {t('SUB_ADMIN_NAME')}
                  <span className='text-red-500'>*</span>
                </>
              }
              type='text'
              autoFocus
              register={register('name', formValidation['subAdminName'])}
              errors={errors}
            />
          </div>
          <div className='px-2 flex'>
            <OInputField
              wrapperClassName='relative z-0 mb-6 w-full group'
              name='email'
              inputLabel={
                <>
                  {t('O_EMAIL_ID')}
                  <span className='text-red-500'>*</span>
                </>
              }
              type='email'
              autoFocus
              register={register('email', formValidation['email'])}
              errors={errors}
            />
          </div>
        </div>
        <div className='pl-3 pr-3'>
          <div className='overflow-x-auto  overflow-y-auto relative rounded-lg border'>
            <table className='w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 '>
              <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                <tr>
                  <th scope='col' className='py-3 px-6 '>
                    {t('SUB_ADMIN_MODULES')}
                  </th>
                  <th scope='col' className='py-3 px-6 '>
                    {t('O_VIEW')}
                  </th>
                  <th scope='col' className='py-3 px-6 '>
                    {t('SUB_ADMIN_ADD')}
                  </th>
                  <th scope='col' className='py-3 px-6 '>
                    {t('SUB_ADMIN_EDIT')}
                  </th>
                  {/* <th scope='col' className='py-3 px-6 '>
                    {t('O_ALL')}
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {permissionJson?.map((item, i) => (
                  <tr
                    key={i}
                    className='bg-white border-b  dark:bg-gray-800 dark:border-gray-700'
                  >
                    <td className='py-4 px-6 border-r '>
                      {capitalize(startCase(item?.manager))}
                    </td>
                    <td className='py-4 px-6 border-r '>
                      {item?.shownView && (
                        <input
                          type='checkbox'
                          name={item?.manager}
                          id='view'
                          checked={item?.view}
                          onChange={onChange}
                        />
                      )}
                    </td>
                    <td className='py-4 px-6 border-r '>
                      {item?.shownAdd && (
                        <input
                          type='checkbox'
                          id='add'
                          name={item?.manager}
                          checked={item?.add}
                          onChange={onChange}
                        />
                      )}
                    </td>
                    <td className='py-4 px-6 border-r '>
                      {item?.shownEdit && (
                        <input
                          type='checkbox'
                          id='edit'
                          name={item?.manager}
                          checked={item?.edit}
                          onChange={onChange}
                        />
                      )}
                    </td>
                    {/* <td className='py-4 px-6 border-r '>
                      {item?.shownAll && (
                        <input
                          type='checkbox'
                          name={item?.manager}
                          onChange={checkAll}
                        />
                      )}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
        <button
          className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
          type='button'
          onClick={() => navigate('/sub-admin-manager')}
        >
          {t('O_BACK')}
        </button>
        <OButton
          disabled={!isDirty && isDisable}
          label={<>{t('O_SAVE')}</>}
          type='submit'
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </>
  )
}

export default SubEdit
